import React from 'react'

const JohnBullIntroduction = () => {
    return (
        <>
            <section id="first" className="about bg2">
                <div className="container">
                    <div className="section-title">
                        <br />
                        <h2 className="animated fadeInDown">Introduction</h2>
                        <div className="bar" />
                        <div className="row">
                            <div className="col-lg-12">
                                <div className=" cd-intro-content bouncy shadow p-4 animated swing">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h3 className="text-left mesee-mg animated fadeInUp ease-out-circ d2 a-1 f2 fw3 heading">
                                                John Bull
                                            </h3>
                                            <p className="text-justify">
                                                When you open the application (app) then you will see a
                                                welcome screen which gives a short tutorial about it.
                                            
                                                When you slide your screen from right to left it will take you
                                                to the next tutorial screen, which tells you to get register
                                                yourself
                                            
                                                Now when you again slide your screen from right to left it
                                                will take you to the next tutorial screen, which is Gift card.
                                                When customer had done a walk-in shopping in the store then he
                                                will be getting an option to buy a gift card for himself or friends
                                            or family, so after purchasing the user can view his/her gift
                                            card in this “GIFT CARD” function. User can buy the gift card
                                            online too When the customer is done with the shopping and the
                                            billing is done, he may earn some points which he/she can redeem
                                            for the future shopping.The points are provided by the merchant
                                            when the customer is doing his/her billing process, the points
                                            will be earned on the basis of shopping To redeem the points
                                            user have a unique barcode where he/she can get offers/earn
                                            points according to shopping After earning the points, customer
                                            can redeem the point by showing the barcode to the merchant to
                                            scan.If user wants to check all of his/her transaction history
                                            then he/she can check it from the “Transaction history” function
                                            from menu.
                                            </p>
                                        </div>
                                        {/* <div className="col-md-4">
                                            <div className="video-responsive mt-5">
                                                <video width="100%" height={200} controls="">
                                                    <source
                                                        src="assets/img/all-banner/Alobah-Final.mp4"
                                                        type="video/mp4"
                                                    />
                                                </video>
                                            </div>
                                        </div> */}
                                    </div>
                                    {/* <div className="col-md-12 p-0">
                                        <p className="text-justify">
                                            be getting an option to buy a gift card for himself or friends
                                            or family, so after purchasing the user can view his/her gift
                                            card in this “GIFT CARD” function. User can buy the gift card
                                            online too When the customer is done with the shopping and the
                                            billing is done, he may earn some points which he/she can redeem
                                            for the future shopping.The points are provided by the merchant
                                            when the customer is doing his/her billing process, the points
                                            will be earned on the basis of shopping To redeem the points
                                            user have a unique barcode where he/she can get offers/earn
                                            points according to shopping After earning the points, customer
                                            can redeem the point by showing the barcode to the merchant to
                                            scan.If user wants to check all of his/her transaction history
                                            then he/she can check it from the “Transaction history” function
                                            from menu.
                                        </p>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default JohnBullIntroduction